import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate, useParams } from "react-router-dom";
import { RouteName } from "constants/route";
import { ICityInput } from "models/city";
import createCityValidator from "validators/createCity.validator";
import { fetchCityByIdApi, updateCityApi } from "api/city";
import { ILoadingWithPage } from "models";

export default function useEditCity() {
  const id: string = useParams().id!;
  const navigate = useNavigate();
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<ILoadingWithPage>({
    button: false,
    page: true,
  });
  const { control, handleSubmit, setValue } = useForm<ICityInput>({
    resolver: yupResolver(createCityValidator),
  });

  useEffect(() => {
    fetchCityByIdApi(id).then(({ data, error }) => {
      if (data?.data) {
        setValue("name", data.data.name);
        setLoading({ button: false, page: false });
      } else showError(error!.message);
    });
    // eslint-disable-next-line
  }, [id]);

  const onSubmit = async (input: ICityInput) => {
    setLoading({ button: true, page: false });
    const { data, error } = await updateCityApi(id, input);
    if (data) {
      showSuccess("City updated Successfully");
      navigate(RouteName.CITY, { replace: true });
    } else {
      showError(error!.message);
    }
    setLoading({ button: false, page: false });
  };

  return { handleSubmit, onSubmit, control, loading };
}
